import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { createSession } from "@/lib/api";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        await createSession(sessionId);
        // Clean the hash
        window.history.replaceState({}, "", window.location.pathname);
        await refresh();
        navigate("/dashboard", { replace: true });
      } catch {
        toast.error("No pudimos iniciar tu sesión. Inténtalo de nuevo.");
        navigate("/", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-[var(--ha-bg)]">
      <div className="flex flex-col items-center gap-4" data-testid="auth-callback-loading">
        <div className="h-14 w-14 rounded-full bg-[var(--ha-primary)] grid place-items-center shadow-sm animate-pulse">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19.8 2c1 5 .5 10-6.7 15.3-4 3-7 3-8 3-1.5 0-2.5-.5-3-1.5-.7-1.6-.5-3.5.5-4.5"/></svg>
        </div>
        <p className="text-[var(--ha-muted)]">Iniciando sesión…</p>
      </div>
    </div>
  );
}
